import useLocalStorage from './useLocalStorage';

const SUBMITTER_UID_LOCALSTORAGE_KEY = 'submitter-uid';

const useSubmitterUid = (): string => {
  const [uid, setUid] = useLocalStorage<string>(SUBMITTER_UID_LOCALSTORAGE_KEY);

  if (uid === null) {
    const newUid = crypto.randomUUID(); // See https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID
    setUid(newUid);
    return newUid;
  }

  return uid;
};

export default useSubmitterUid;
